import styled, { css } from "styled-components";

export const StyledMapWrapper = styled.div`

`;

export const StyledMapContainer = styled.div`
   ${({ readonly }) => readonly && css`
      pointer-events: none;
      opacity: 0.7;
  `};
`;

export const StyledMap = styled.div`
   width: 100%;
   height: 260px;
`;